/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type DependencyType =
  (typeof DependencyType)[keyof typeof DependencyType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DependencyType = {
  MUST_FINISH_FIRST: "MUST_FINISH_FIRST",
  CAN_START_IN_PARALLEL: "CAN_START_IN_PARALLEL",
  INFORMATIONAL: "INFORMATIONAL",
} as const;
